import React, { FC } from 'react';
import styled from 'styled-components';
import { TextEllipsis } from './TextEllipsis';

export interface TextLabelProps {
  htmlTag?: Exclude<keyof HTMLElementTagNameMap, 'a' | 'button'>;
  ellipsis?: boolean;
  value: string;
}

export const TextLabel: FC<TextLabelProps> = (props) => {
  const { value, htmlTag: HtmlTag = 'small', ellipsis = true } = props;

  if (!ellipsis) {
    return (
      <HtmlTagWrapper>
        <HtmlTag>{value}</HtmlTag>
      </HtmlTagWrapper>
    );
  }

  return (
    <TextEllipsis tooltip={value}>
      <HtmlTagWrapper>
        <HtmlTag>{value}</HtmlTag>
      </HtmlTagWrapper>
    </TextEllipsis>
  );
};

export const HtmlTagWrapper = styled.div`
  white-space: pre;
`;
